import { faUpload, faCloudUpload, faCloudUploadAlt, faFileUpload, faFileImport } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useRef } from "react";
import { FileImportService } from "../services/fileImport.service";

const FileUpload = (props: any) => {
  const inputFile = useRef<HTMLInputElement>();
  const [fileName, setFileName] = useState<string | null>(null);
  const [uploadSuccess, setUploadSuccess] = useState<any>(false);

  const handleClick = () => {
    inputFile.current?.click();
  };

  const handleChange = () => {
    setFileName(inputFile.current.files[0].name);

    const currentFile = inputFile.current?.files[0];
    const formData = new FormData();

    formData.append("File", currentFile);
    formData.append("Entity", props.entityToImport);

    FileImportService.Import(formData, props.entityToImport, currentFile.type).then((result: any) => {
     
      if (result) {
        inputFile.current.value = '';
        props.onSuccess(null);
      }

      return setUploadSuccess(result);
    });
  };

  return (
    <div className="m-3">
      <input
        ref={inputFile}
        onChange={handleChange}
        className="d-none"
        type="file"
      />

      <button
        type="button"
        onClick={handleClick}
        className={`btn btn-outline-${uploadSuccess ? "success" : "primary"}`}
      >
        <FontAwesomeIcon icon={faFileImport} className='me-2' />
        Importar Arquivo
      </button>
      <label style={{ paddingLeft: 15 }} className={`text-${uploadSuccess ? "success" : "danger"}`}>
        {fileName}
      </label>
    </div>
  );
}

export default FileUpload;